import React from "react";

export class Page extends React.Component {
    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="page">
                        {this.props.children}
                    </div>
                </div>
            </div>
        )
    }
}

export class PageHeader extends React.Component {
    render() {
        return (
            <div className="page-header">
                <div className="col-lg-12">
                    {/*this.props.children*/}
                    <span className="page-header-title" dangerouslySetInnerHTML={{ __html: this.props.title }} />
                    <small dangerouslySetInnerHTML={{ __html: this.props.subtitle }} />
                    {this.props.right ? this.props.right() : ""}
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export class PageBody extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            alerts: []
        }

        document.addEventListener('newAlert', this.handleNewAlert.bind(this), false);
    }

    componentWillUnmount() {
        document.removeEventListener('newAlert', this.handleNewAlert.bind(this));
    }

    handleNewAlert(e) {
        let alerts = this.state.alerts;

        alerts.push(e.detail.alert);

        this.setState({ alerts });
    }

    handleRemoveAlert() {
        let alerts = this.that.state.alerts;
       
        alerts.splice(this.index, 1);

        this.that.setState({ alerts });
    }

    renderAlerts() {
        return (
            <div className="alerts">
                {this.state.alerts.map((alert, index) => {
                    return (
                        <div key={"alert" + index} className={"alert alert-" + alert.type}>
                            <span dangerouslySetInnerHTML={{ __html: alert.text }} />
                            <span className="fa fa-close pull-right" style={{ cursor: "pointer" }} onClick={this.handleRemoveAlert.bind({ that: this, index })} />
                        </div>
                    )
                })}
            </div>
        )
    }

    render() {
        return (
            <div className="page-body">
                <div className="col-lg-12">
                    {this.renderAlerts()}
                    {this.props.children}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/base/Page.jsx